/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VwbWorkspaceAuditLog
 */
export interface VwbWorkspaceAuditLog {
    /**
     * ID of the workspace
     * @type {string}
     * @memberof VwbWorkspaceAuditLog
     */
    workspaceId?: string;
    /**
     * Type of change made to the workspace
     * @type {string}
     * @memberof VwbWorkspaceAuditLog
     */
    changeType?: string;
    /**
     * Username of the user that made the workspace change
     * @type {string}
     * @memberof VwbWorkspaceAuditLog
     */
    actorEmail?: string;
    /**
     * Timestamp the workspace was changed
     * @type {string}
     * @memberof VwbWorkspaceAuditLog
     */
    changeTime?: string;
    /**
     * Application type associated with the event when present in properties
     * @type {string}
     * @memberof VwbWorkspaceAuditLog
     */
    appType?: string;
    /**
     * Subject affected by the change when available
     * @type {string}
     * @memberof VwbWorkspaceAuditLog
     */
    changeSubjectId?: string;
    /**
     * Additional event properties in serialized form
     * @type {string}
     * @memberof VwbWorkspaceAuditLog
     */
    properties?: string;
}

/**
 * Check if a given object implements the VwbWorkspaceAuditLog interface.
 */
export function instanceOfVwbWorkspaceAuditLog(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VwbWorkspaceAuditLogFromJSON(json: any): VwbWorkspaceAuditLog {
    return VwbWorkspaceAuditLogFromJSONTyped(json, false);
}

export function VwbWorkspaceAuditLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): VwbWorkspaceAuditLog {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'workspaceId': !exists(json, 'workspaceId') ? undefined : json['workspaceId'],
        'changeType': !exists(json, 'changeType') ? undefined : json['changeType'],
        'actorEmail': !exists(json, 'actorEmail') ? undefined : json['actorEmail'],
        'changeTime': !exists(json, 'changeTime') ? undefined : json['changeTime'],
        'appType': !exists(json, 'appType') ? undefined : json['appType'],
        'changeSubjectId': !exists(json, 'changeSubjectId') ? undefined : json['changeSubjectId'],
        'properties': !exists(json, 'properties') ? undefined : json['properties'],
    };
}

export function VwbWorkspaceAuditLogToJSON(value?: VwbWorkspaceAuditLog | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'workspaceId': value.workspaceId,
        'changeType': value.changeType,
        'actorEmail': value.actorEmail,
        'changeTime': value.changeTime,
        'appType': value.appType,
        'changeSubjectId': value.changeSubjectId,
        'properties': value.properties,
    };
}

